/* ==========================================================================
   Bibi & Co. — theme.js
   Vanilla JS. No dependencies. Deferred.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var strings = window.themeStrings || {};

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
    return (cents / 100).toFixed(2);
  }

  /* ---------------- Toast ---------------- */
  var toastEl = null, toastTimer = null;
  function toast(message) {
    if (!message) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------------- Drawers ---------------- */
  var lastFocused = null;

  function openDrawer(name) {
    var drawer = $('[data-drawer="' + name + '"]');
    if (!drawer) return;
    lastFocused = document.activeElement;
    closeAllDrawers(true);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    var overlay = $('[data-overlay]');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    var focusTarget = drawer.querySelector('[data-drawer-focus]') || drawer.querySelector('button, [href], input, select, textarea');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 120);
    var toggles = $$('[data-drawer-open="' + name + '"]');
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
  }

  function closeAllDrawers(skipOverlay) {
    $$('[data-drawer]').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    $$('[data-drawer-open]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (!skipOverlay) {
      var overlay = $('[data-overlay]');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      lastFocused = null;
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      var name = opener.getAttribute('data-drawer-open');
      var drawer = $('[data-drawer="' + name + '"]');
      if (drawer && drawer.classList.contains('is-open')) closeAllDrawers();
      else openDrawer(name);
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-overlay]')) {
      e.preventDefault();
      closeAllDrawers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  /* ---------------- Header on scroll ---------------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 10) header.classList.add('header--scrolled');
      else header.classList.remove('header--scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal(scope) {
    var els = $$('.reveal:not(.is-visible)', scope);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Cart ---------------- */
  function cartSectionsToRender() {
    var list = ['cart-drawer'];
    if ($('[data-cart-page]')) list.push('main-cart');
    return list;
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (parseInt(count, 10) > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function renderCart(openAfter) {
    var url = window.location.pathname + '?sections=' + cartSectionsToRender().join(',');
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        Object.keys(data).forEach(function (key) {
          var html = new DOMParser().parseFromString(data[key], 'text/html');
          var source = html.querySelector('[data-cart-inner]');
          var target = document.querySelector('[data-cart-inner][data-cart-source="' + key + '"]');
          if (source && target) {
            target.innerHTML = source.innerHTML;
            if (source.hasAttribute('data-cart-count-value')) {
              updateCartCount(source.getAttribute('data-cart-count-value'));
            }
          }
        });
        initReveal(document);
        if (openAfter) openDrawer('cart');
      })
      .catch(function () { window.location.href = routes + 'cart'; });
  }

  function setLoading(el, state) {
    if (!el) return;
    el.classList.toggle('is-loading', !!state);
    if (state) el.setAttribute('aria-disabled', 'true');
    else el.removeAttribute('aria-disabled');
  }

  function addToCart(body, button) {
    setLoading(button, true);
    return fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        setLoading(button, false);
        if (!res.ok) {
          toast(res.json.description || res.json.message || strings.cartError || 'Could not add to bag');
          return null;
        }
        return renderCart(true);
      })
      .catch(function () {
        setLoading(button, false);
        toast(strings.cartError || 'Could not add to bag');
      });
  }

  function changeCartLine(line, quantity) {
    var drawerBody = $('[data-cart-inner]');
    if (drawerBody) drawerBody.style.opacity = '0.55';
    return fetch(routes + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { return renderCart(false); })
      .then(function () {
        $$('[data-cart-inner]').forEach(function (el) { el.style.opacity = ''; });
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    // Quick add / add to cart buttons that carry a variant id
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var id = quick.getAttribute('data-variant-id');
      if (!id) return;
      addToCart({ items: [{ id: parseInt(id, 10), quantity: 1 }] }, quick);
      return;
    }

    // Cart line remove
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeCartLine(parseInt(remove.getAttribute('data-line'), 10), 0);
      return;
    }

    // Quantity steppers
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      var wrap = qtyBtn.closest('.qty');
      var input = wrap ? wrap.querySelector('input') : null;
      if (!input) return;
      var step = qtyBtn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
      var min = parseInt(input.getAttribute('min') || '0', 10);
      var next = (parseInt(input.value, 10) || 0) + step;
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-line'), 10);
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    changeCartLine(line, qty);
  });

  /* ---------------- Product form ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[data-add-button]');
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.classList.remove('is-visible');
    var formData = new FormData(form);
    var body = { items: [{ id: parseInt(formData.get('id'), 10), quantity: parseInt(formData.get('quantity') || '1', 10) }] };
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) body.items[0].properties = properties;
    if (!body.items[0].id) {
      if (errorEl) { errorEl.textContent = strings.unavailable || 'Please select an option'; errorEl.classList.add('is-visible'); }
      return;
    }
    addToCart(body, button);
  });

  /* ---------------- Variant picker ---------------- */
  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var scriptEl = document.getElementById(picker.getAttribute('data-variants-id'));
      if (!scriptEl) return;
      var variants;
      try { variants = JSON.parse(scriptEl.textContent); } catch (err) { return; }
      var section = picker.closest('[data-product-section]') || document;

      picker.addEventListener('change', function () {
        var selected = $$('input:checked, select', picker).map(function (el) { return el.value; });
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        updateForVariant(section, picker, match);
      });
    });
  }

  function updateForVariant(section, picker, variant) {
    var priceEl = section.querySelector('[data-price-wrapper]');
    var addButton = section.querySelector('[data-add-button]');
    var addLabel = addButton ? addButton.querySelector('.btn__label') : null;
    var idInput = section.querySelector('[data-variant-input]');
    var skuEl = section.querySelector('[data-sku]');
    var stickyPrice = section.querySelector('[data-sticky-price]');

    if (!variant) {
      if (addButton) { addButton.setAttribute('disabled', 'disabled'); }
      if (addLabel) addLabel.textContent = strings.unavailable || 'Unavailable';
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (addButton) {
      if (variant.available) {
        addButton.removeAttribute('disabled');
        if (addLabel) addLabel.textContent = strings.addToCart || 'Add to bag';
      } else {
        addButton.setAttribute('disabled', 'disabled');
        if (addLabel) addLabel.textContent = strings.soldOut || 'Sold out';
      }
    }

    if (priceEl) {
      var html = '<span class="price' + (variant.compare_at_price > variant.price ? ' price--on-sale' : '') + '">';
      html += '<span class="' + (variant.compare_at_price > variant.price ? 'price__sale' : '') + '">' + formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price > variant.price) {
        html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
      }
      html += '</span>';
      priceEl.innerHTML = html;
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    if (skuEl) skuEl.textContent = variant.sku || '';

    // Update the option label read-outs
    $$('[data-option-value]', section).forEach(function (el) {
      var index = parseInt(el.getAttribute('data-option-value'), 10);
      if (variant.options[index] !== undefined) el.textContent = variant.options[index];
    });

    // Gallery: jump to variant image
    var mediaId = variant.featured_media ? variant.featured_media.id : variant.featured_media_id;
    if (mediaId && section.querySelector('[data-media-id="' + mediaId + '"]')) {
      showGallerySlide(section, mediaId);
    }

    // Keep the URL shareable
    if (variant.id && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* ---------------- Product gallery ---------------- */
  function showGallerySlide(scope, mediaId) {
    var slides = $$('[data-media-id]', scope);
    var counter = scope.querySelector('[data-gallery-counter]');
    slides.forEach(function (slide, i) {
      var active = slide.getAttribute('data-media-id') === String(mediaId);
      if (slide.classList.contains('gallery__slide')) {
        slide.classList.toggle('is-active', active);
        if (active && counter) counter.textContent = (Math.floor(i / 1) + 1);
      }
    });
    $$('[data-gallery-thumb]', scope).forEach(function (thumb) {
      thumb.setAttribute('aria-current', thumb.getAttribute('data-thumb-id') === String(mediaId) ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    e.preventDefault();
    var scope = thumb.closest('[data-product-section]') || document;
    showGallerySlide(scope, thumb.getAttribute('data-thumb-id'));
  });

  /* ---------------- Sticky add to cart ---------------- */
  function initStickyAtc() {
    var sticky = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  document.addEventListener('click', function (e) {
    var jump = e.target.closest('[data-sticky-add]');
    if (!jump) return;
    e.preventDefault();
    var form = $('[data-product-form]');
    if (form) {
      var btn = form.querySelector('[data-add-button]');
      if (btn) btn.click();
    }
  });

  /* ---------------- Wishlist (local) ---------------- */
  var WISHLIST_KEY = 'bibi:wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
  }
  function syncWishlist(scope) {
    var list = getWishlist();
    $$('[data-wishlist]', scope).forEach(function (btn) {
      btn.setAttribute('aria-pressed', list.indexOf(btn.getAttribute('data-wishlist')) > -1 ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist');
    var list = getWishlist();
    var index = list.indexOf(handle);
    if (index > -1) { list.splice(index, 1); toast(strings.wishlistRemoved || 'Removed from saved'); }
    else { list.push(handle); toast(strings.wishlistAdded || 'Saved'); }
    setWishlist(list);
    syncWishlist(document);
  });

  /* ---------------- Recently viewed ---------------- */
  var RECENT_KEY = 'bibi:recent';
  function trackRecentlyViewed() {
    var el = $('[data-recent-track]');
    if (!el) return;
    var handle = el.getAttribute('data-recent-track');
    var list;
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, 12);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) { /* noop */ }
  }

  function renderRecentlyViewed() {
    var container = $('[data-recently-viewed]');
    if (!container) return;
    var current = container.getAttribute('data-exclude') || '';
    var limit = parseInt(container.getAttribute('data-limit') || '4', 10);
    var list;
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h && h !== current; }).slice(0, limit);
    if (!list.length) return;
    var target = container.querySelector('[data-recently-viewed-grid]');
    if (!target) return;
    Promise.all(list.map(function (handle) {
      return fetch(routes + 'products/' + handle + '?section_id=product-card-ajax')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (results) {
      var html = results.filter(Boolean).map(function (chunk) {
        var doc = new DOMParser().parseFromString(chunk, 'text/html');
        var card = doc.querySelector('[data-card-wrapper]');
        return card ? card.outerHTML : '';
      }).join('');
      if (!html) return;
      target.innerHTML = html;
      container.hidden = false;
      syncWishlist(container);
      initReveal(container);
    });
  }

  /* ---------------- Product recommendations ---------------- */
  function initRecommendations() {
    var el = $('[data-recommendations][data-url]');
    if (!el) return;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        if (!text) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var inner = doc.querySelector('[data-rec-inner]');
        var target = el.querySelector('[data-rec-inner]');
        if (!inner || !target || !inner.querySelector('.product-grid')) return;
        target.innerHTML = inner.innerHTML;
        el.hidden = false;
        syncWishlist(el);
        initReveal(el);
      })
      .catch(function () { /* recommendations are optional */ });
  }

  /* ---------------- Predictive search ---------------- */
  function initSearch() {
    var input = $('[data-search-input]');
    var results = $('[data-search-results]');
    if (!input || !results) return;
    var timer = null;
    var controller = null;

    input.addEventListener('input', function () {
      var value = input.value.trim();
      clearTimeout(timer);
      if (value.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = routes + 'search/suggest?q=' + encodeURIComponent(value) +
          '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () { /* aborted or offline — the form still submits normally */ });
      }, 260);
    });
  }

  /* ---------------- Announcement rotation ---------------- */
  function initAnnouncement() {
    var wrapper = $('[data-announcement]');
    if (!wrapper) return;
    var slides = $$('.announcement__slide', wrapper);
    if (slides.length < 2) return;
    var index = 0;
    setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, 5000);
  }

  /* ---------------- Facets (collection filtering) ---------------- */
  function initFacets() {
    var form = $('[data-facet-form]');
    if (!form) return;
    form.addEventListener('change', function () {
      if (form.querySelector('[data-facet-auto]')) form.submit();
    });
  }

  /* ---------------- Sort ---------------- */
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-by]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------------- Init ---------------- */
  function init() {
    initReveal(document);
    initVariantPickers();
    initStickyAtc();
    initSearch();
    initAnnouncement();
    initFacets();
    syncWishlist(document);
    trackRecentlyViewed();
    renderRecentlyViewed();
    initRecommendations();

    // Open cart drawer when arriving with ?cart=open
    if (window.location.search.indexOf('cart=open') > -1) openDrawer('cart');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-run bindings after Shopify theme editor updates a section
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initVariantPickers();
    initStickyAtc();
    initSearch();
    initAnnouncement();
    syncWishlist(e.target);
    renderRecentlyViewed();
    initRecommendations();
  });

  window.BibiTheme = { openDrawer: openDrawer, closeDrawers: closeAllDrawers, renderCart: renderCart, toast: toast };
})();
